export default [{ label: 'Dollar Blocks', value: 'dollarCount' }, { label: 'Equal Blocks', value: 'blockCount' }];



// WEBPACK FOOTER //
// ./src/constants/incrementTypes.js